module.exports = __webpack_public_path__ + "static/img/productimg11.ad0ce577.png";